import { createTheme } from '@mui/material/styles';

export const rubricaeTheme = createTheme({
  palette: {
    primary: {
      main: '#263145',
      dark: '#141a24',
    },
    secondary: {
      main: '#DE3142',
    },
    text: {
      primary: '#263145',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    allVariants: {
      color: '#263145'
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#FFFFFF',
          backgroundColor: '#263145',
          '&:hover': {
            backgroundColor: '#141a24'
          },
        },
      },
    },
  },
});